import {
  getPOSDetailsAPI,
  addPOSDetailsAPI,
  updatePOSDetailsAPI,
  deletePOSDetailsAPI
} from '../adapter/adapter'

export function getAllPOSHelper() {
  let promise = new Promise(function (resolve, reject) {
    getPOSDetailsAPI()
      .then((res) => {
        console.log('getAllPOSHelper res: ', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get POS Failure')
        }
      })
      .catch((err) => {
        console.log('getAllPOSHelper err: ', err)
        reject('Get POS Failure')
      })
  })

  return promise
}

export function addPOSHelper(data) {
  let reqData = {
    pos_account_name: data.pos_account_name,
    pos_bank_account: data.pos_bank_account,
    payment_receiver_bank_id: data.payment_receiver_bank_id,
    same_bank_transaction_fees: data.same_bank_transaction_fees,
    other_bank_transaction_fees: data.other_bank_transaction_fees
  }

  let promise = new Promise(function (resolve, reject) {
    addPOSDetailsAPI(reqData)
      .then((res) => {
        console.log('addPOSHelper res: ', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Add POS Failure')
        }
      })
      .catch((err) => {
        console.log('addPOSHelper err: ', err)
        reject('Add POS Failure')
      })
  })

  return promise
}

export function updatePOSHelper(data) {
  let reqData = {
    id: data.id,
    pos_account_name: data.pos_account_name,
    pos_bank_account: data.pos_bank_account,
    payment_receiver_bank_id: data.payment_receiver_bank_id,
    same_bank_transaction_fees: data.same_bank_transaction_fees,
    other_bank_transaction_fees: data.other_bank_transaction_fees
  }

  let promise = new Promise(function (resolve, reject) {
    updatePOSDetailsAPI(reqData)
      .then((res) => {
        console.log('updatePOSHelper res: ', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Update POS Failure')
        }
      })
      .catch((err) => {
        console.log('updatePOSHelper err: ', err)
        reject('Update POS Failure')
      })
  })

  return promise
}

export function deletePOSHelper(id) {
  let reqData = {
    id: id
  }

  let promise = new Promise(function (resolve, reject) {
    deletePOSDetailsAPI(reqData)
      .then((res) => {
        console.log('deletePOSHelper res: ', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.code === 200) {
          resolve(true)
        } else {
          reject('Delete POS Failure')
        }
      })
      .catch((err) => {
        console.log('deletePOSHelper err: ', err)
        reject('Delete POS Failure')
      })
  })

  return promise
}

